"use strict";
var types_1 = require("../types");
var extensionsMap = Object.create(null);
extensionsMap.mp4 = types_1.MediaStreamTypes.MP4;
extensionsMap.webm = types_1.MediaStreamTypes.WEBM;
extensionsMap.m3u8 = types_1.MediaStreamTypes.HLS;
extensionsMap.mpd = types_1.MediaStreamTypes.DASH;
var anchorElement = document.createElement('a');
function detectStreamType(url) {
    anchorElement.href = url;
    var streamType = extensionsMap[getExtFromPath(anchorElement.pathname)];
    if (!streamType) {
        throw new Error("Vidi: cannot auto-detect url '" + url + "'. Please specify type manually using the MediaStream interface.");
    }
    else {
        return streamType;
    }
}
exports.detectStreamType = detectStreamType;
function getExtFromPath(path) {
    return path.split('.').pop();
}
exports.getExtFromPath = getExtFromPath;
//# sourceMappingURL=detect-stream-type.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/media-streams/detect-stream-type.js
// module id = 2763
// module chunks = 66